import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Grid, Input } from 'framework-ui-components';
import { Button } from 'framework-ui-components/Components/V2';

import DeleteIcon from 'framework-ui-components/Components/Icons/DeleteIcon';
import SearchIcon from 'framework-ui-components/Components/Icons/SearchIcon';

class InputRicerca extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchTerm: '',
    };
  }

  onChangeSearch = (event) => {
    const testoRicerca = event.target.value.trim();

    if (testoRicerca === '') {
      this.setState({ searchTerm: testoRicerca }, () => this.clickCerca());
    } else {
      this.setState({ searchTerm: testoRicerca });
    }
  }

  clickCerca = () => {
    const { searchTerm } = this.state;
    const { onClickCerca } = this.props;

    onClickCerca && onClickCerca(searchTerm);
  }

  onSearchKeyDown = (event) => {
    if (event.keyCode === 13) {
      this.clickCerca();
    }
  }

  svuotaRicerca = (reload) => {
    this.setState({ searchTerm: '' }, () => reload && this.clickCerca());
    if (this.refInput.formattedField.current) this.refInput.formattedField.current.value = '';
    if (this.refInput.unformattedField.current) this.refInput.unformattedField.current.value = '';
  }

  render() {
    const { buttonText, title } = this.props;
    const { searchTerm } = this.state;

    return (
      <Grid.Row className="ricercaSemplice">
        <Grid.Col md="9" className="input__area">
          <Fragment>
            <Input
              title={title}
              value={searchTerm}
              autoFocus
              // eslint-disable-next-line no-return-assign
              ref={(r) => this.refInput = r}
              onChange={this.onChangeSearch}
              onKeyDown={this.onSearchKeyDown}
            />
            {searchTerm
              && (
                <Button
                  icon
                  small
                  emphasis={Button.Emphasis.LOW}
                  onClick={() => this.svuotaRicerca(true)}
                  className="deleteRicerca__icon"
                >
                  <DeleteIcon />
                </Button>
              )}
            <SearchIcon className="input__title__icon" />
          </Fragment>
        </Grid.Col>
        <Grid.Col md="3">
          <Button primary emphasis={Button.Emphasis.HIGH} onClick={this.clickCerca} className="buttonCerca">{buttonText}</Button>
        </Grid.Col>
      </Grid.Row>
    );
  }
}

InputRicerca.propTypes = {
  buttonText: PropTypes.string,
  onClickCerca: PropTypes.func.isRequired,
  title: PropTypes.string,
};

InputRicerca.defaultProps = {
  title: 'Cerca domande per nome, cognome o codice fiscale',
  buttonText: 'Cerca',
};

export default InputRicerca;
